import * as React from "react";
import PropTypes from "prop-types";
import prefixStyles from "nx-components/utils/prefixStyles";
import { IconThermostat } from "nx-components/Icons";

function getTemperature(value) {
  let temp = "--";
  value.modifiers.forEach((modifier) => {
    if (modifier.startsWith("temperature-")) {
      temp = modifier.substring(modifier.indexOf('-')+1) || temp;
    }
  });
  return `${temp}°`;
}

function DeviceThermostatIcon({ value, style, includeTemperature }) {
  if (!includeTemperature) {
    return <IconThermostat style={style} />;
  }

  let styles = prefixStyles({
    root: {
      lineHeight: "0",
      margin: "0.2em 0.1em",
      fontSize: "0.5em",
      width: "1.5em",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      ...style,
    },
    icon: {
      margin: "0 -0.25em",
    },
    temperature: {
      fontSize: "0.65em",
      marginLeft: "0.1em",
    },
  });

  const temp = getTemperature(value);
  if (temp.length > 3) {
    // Celsius and very high Fahreinheit temeratures can be long
    styles.temperature.fontSize = "0.35em";
  }
  return (
    <div style={styles.root}>
      <IconThermostat style={styles.icon} />
      <span style={styles.temperature}>{temp}</span>
    </div>
  );
}
DeviceThermostatIcon.propTypes = {
  value: PropTypes.shape({
    modifiers: PropTypes.arrayOf(PropTypes.string).isRequired,
  }),
  style: PropTypes.object,
  includeTemperature: PropTypes.bool.isRequired,
};

export default DeviceThermostatIcon;



// WEBPACK FOOTER //
// ./src/components/DeviceThermostatIcon.jsx